<ng-template #content let-c="close" let-d="dismiss">
    <div class="lna-modal-header">
      <h4 class="modal-title" id="modal-basic-title">
      </h4>
      <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
    </div>
    <div class="lna-modal-body map-modal-body">
        <p>{{ text }}</p>
    </div>
</ng-template>
  